import React from 'react';
import { Spinner } from 'react-bootstrap';

const styles = {
  spinnerContainerStyle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    opacity: 1, // Ajout d'opacité pour la transition
    transition: 'opacity 300ms ease-in-out', // Transition douce
  },
  spinnerHiddenStyle: {
    opacity: 0, // Masquer après chargement
    visibility: 'hidden',
  },
};

function FallbackSpinner({ isLoading }) {
  return (
    <div
      style={{
        ...styles.spinnerContainerStyle,
        ...(isLoading ? {} : styles.spinnerHiddenStyle),
      }}
    >
      <Spinner animation="grow" />
    </div>
  );
}

export default FallbackSpinner;
